var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1758_3695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 4.07825e-05C15.5228 4.07825e-05 20 4.4772 20 10C20 15.5228 15.5228 20 10 20C4.4772 20 4.14787e-05 15.5228 4.14787e-05 10C-0.0156734 4.49286 4.43598 0.0157556 9.94308 4.07825e-05C9.96206 -1.35942e-05 9.98104 -1.35942e-05 10 4.07825e-05Z",
    fill: "#FFCB05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5395 7.24324L8.43723 14.3455L4.45996 10.3967L6.0793 8.80575L8.43723 11.1353L13.9202 5.65234L15.5395 7.24324Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1758_3695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.f2030a3b95abe26a672541be21a3881e.svg";
export { ForwardRef as ReactComponent };